
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/sculpture",
      function () {
        return require("private-next-pages/works/sculpture.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/sculpture"])
      });
    }
  